import "./PantallaCarga.css";

/**
 * Pantalla de carga del panel.
 *
 * Se usa en dos momentos:
 *   - mientras se valida el login (tema oscuro, sobre la pantalla de acceso)
 *   - al entrar al panel, mientras se piden el usuario y los permisos
 *     (tema claro). Antes ese momento devolvia null y quedaba la pantalla
 *     en blanco sin ninguna senal de que algo estaba pasando.
 *
 * La barra es indeterminada a proposito: no conocemos el progreso real, y
 * fingir un porcentaje es peor que no mostrarlo.
 */
function PantallaCarga({ mensaje = "Loading...", tema = "claro", fijo = false }) {
  return (
    <div
      className={`pc pc--${tema} ${fijo ? "pc--fijo" : ""}`}
      role="status"
      aria-live="polite"
      aria-label={mensaje}
    >
      <div className="pc-caja">
        <img src="/image/ADC-Logo.png" alt="" className="pc-logo" />

        <div className="pc-barra">
          <span />
        </div>

        <p className="pc-mensaje">{mensaje}</p>
      </div>
    </div>
  );
}

export default PantallaCarga;
